<!--
 * @Author: cmchiu
 * @Date: 2023-05-02 16:15:29
 * @LastEditTime: 2023-07-04 14:42:04
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\views\TeacherSearch.vue
 * 
-->
<template>
    <div class="teacher-search">
        <breadcrumb />

        <div class="layer-container">
            <h2 class="page-title">教師專業資訊{{ !$route.query.colg ? '' : '《' + $route.query.colg + '》' }}</h2>
            <div class="teacher-category">
                <!-- Simple Search Bar -->
                <div class="simple-search w-100 d-flex" v-if="!$route.query.colg">
                    <input
                        class="simple-search__input"
                        type="search"
                        id="search"
                        name="search"
                        placeholder="教師名稱、學院、系所"
                        v-model.trim="teacher.filter.keyword"
                        @keyup.enter="getTeacherLs(1)"
                        @focus="resetData(teacher)"
                    />
                    <button class="simple-search__button" @click="getTeacherLs()">搜 尋</button>
                </div>
                <!-- Advanced Search Bar -->
                <div class="advanced-search w-100 d-flex" v-else>
                    <select
                        class="advanced-search__select"
                        v-model.trim="teacher.filter.dept"
                        @change="getTeacherLs(1)"
                    >
                        <option value="">全部</option>
                        <option
                            v-for="(opt, index) in deptLs"
                            :key="index"
                            :label="opt.Dept"
                            :value="opt.Dept"
                        ></option>
                    </select>
                    <input
                        class="advanced-search__input"
                        type="search"
                        id="search"
                        name="search"
                        placeholder="教師名稱、學院、系所"
                        v-model.trim="teacher.filter.keyword"
                        @keyup.enter="getTeacherLs(1)"
                        @focus="resetData(teacher)"
                    />
                    <button class="advanced-search__button" @click="getTeacherLs()">搜 尋</button>
                </div>

                <!-- College Category -->
                <div class="teacher-category__wrapper" v-if="!$route.query.colg && !teacher.filter.keyword">
                    <h3 class="page-subtitle">學院分類</h3>
                    <ul class="teacher-category__list w-100 d-flex flex-wrap">
                        <li class="teacher-category__item" v-for="(opt, index) in colgLs" :key="index">
                            <router-link
                                class="teacher-category__link w-100"
                                :to="{ path: $route.path, query: { colg: opt.Colg } }"
                                v-text="opt.Colg"
                            ></router-link>
                        </li>
                    </ul>
                </div>

                <!-- Teacher Info -->
                <div class="teacher-info__wrapper" v-else>
                    <h3 class="page-subtitle">教師資訊</h3>
                    <table class="info-table">
                        <thead>
                            <tr>
                                <th>學院</th>
                                <th>系所</th>
                                <th>姓名</th>
                                <th>職稱</th>
                                <th>專兼任</th>
                                <th>分機</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(person, index) in teacher.data" :key="index">
                                <td v-text="person.Colg"></td>
                                <td v-text="person.Dept"></td>
                                <td v-text="person.Name"></td>
                                <td v-text="person.Title"></td>
                                <td v-text="person.Type"></td>
                                <td v-text="person.Tel"></td>
                                <td>
                                    <router-link
                                        class="info-table__link d-flex align-items-center"
                                        :to="{ path: '/TeacherProfile', query: { acct: person.Acct } }"
                                        target="_blank"
                                    >
                                        <img class="info-table__icon" src="images/link.svg" alt="" />
                                        個人檔案
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <pagination
                        :page-size="teacher.pages.pageSize"
                        :total.sync="teacher.pages.totalResult"
                        :currPage.sync="teacher.pages.pageCurrent"
                        @page-change="pageChange"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import XEUtils from 'xe-utils'
import { getColgLs, getDeptLs, getTeacherLs } from '@/api/teacher'
import { breadcrumb, pagination } from '@c'

export default {
    name: 'teacherSearch',

    components: { breadcrumb, pagination },

    data() {
        const vm = this

        return {
            configs: {
                loading: false,
            },
            colgLs: [],
            deptLs: [],
            teacher: {
                filter: {
                    colg: vm.$route.query.colg,
                    dept: '',
                    keyword: '',
                },
                data: [],
                pages: {
                    totalResult: 0, // 總筆數
                    pageSize: 9, // 分頁大小
                    pageCurrent: 1, // 目前頁次
                },
            },
        }
    },

    created() {
        this.getColgLs().then(() => {
            if (this.$route.query.colg) {
                this.getDeptLs().then(() => {
                    this.getTeacherLs(1)
                })
            }
        })
    },

    methods: {
        async getColgLs() {
            const vm = this
            vm.configs.loading = true
            await getColgLs()
                .then(res => {
                    // handle success
                    vm.colgLs = res.Items
                })
                .catch(err => {
                    // handle error
                    vm.colgLs = []
                    console.log(err)
                })
                .finally(() => {
                    // always executed
                    vm.configs.loading = false
                })
        },

        async getDeptLs() {
            const vm = this
            vm.configs.loading = true
            await getDeptLs({ colg: vm.$route.query.colg })
                .then(res => {
                    // handle success
                    vm.deptLs = res.Items
                })
                .catch(err => {
                    // handle error
                    vm.deptLs = []
                    console.log(err)
                })
                .finally(() => {
                    // always executed
                    vm.configs.loading = false
                })
        },

        async getTeacherLs(chgFilters) {
            const vm = this
            const filter = vm.teacher.filter
            const pages = vm.teacher.pages
            document.getElementById('search').blur() //讓搜尋框失焦
            vm.configs.loading = true
            if (chgFilters) pages.pageCurrent = 1 //當條件改變時, 將當前頁次改回第1頁
            let params = {
                College: filter.colg,
                Dep: filter.dept,
                Keyword: filter.keyword,
                PageSize: pages.pageSize,
                PageCurrent: pages.pageCurrent,
            }
            await getTeacherLs(params)
                .then(res => {
                    // handle success
                    vm.teacher.data = res.Items
                    pages.totalResult = res.TotalResult
                    if (Math.ceil(pages.totalResult / pages.pageSize) < pages.pageCurrent) {
                        pages.pageCurrent = 1
                    }
                })
                .catch(err => {
                    // handle error
                    vm.resetData(vm.teacher)
                    console.log(err)
                })
                .finally(() => {
                    // always executed
                    vm.configs.loading = false
                })
        },

        pageChange(val) {
            this.teacher.pages.pageCurrent = val
            this.getTeacherLs()
        },

        resetData(obj) {
            obj.data = []
            obj.pages = {
                totalResult: 0, // 總筆數
                pageSize: 9, // 分頁大小
                pageCurrent: 1, // 目前頁次
            }
        },
    },
}
</script>

<select lang="scss" scoped></select>
